import { Avatar, Box, Typography } from '@mui/joy';
import PersonIcon from '@mui/icons-material/Person';
import { FC, JSX } from 'react';
import { useTranslation } from 'react-i18next';

type ProfileMenuItemProps = {
  variant?: 'plain' | 'outlined' | 'soft' | 'solid';
  onClick?: () => void;
};

export const ProfileMenuItemBase: FC<ProfileMenuItemProps> = ({
  variant = 'plain',
  onClick,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 0.75,
        width: '100%',
        cursor: 'pointer',
      }}
    >
      <Avatar
        variant="outlined"
        size="sm"
        sx={{
          '--Avatar-size': '14',
          bgcolor: 'transparent',
          color: 'text.secondary',
          p: 0.5,
        }}
      >
        <PersonIcon fontSize="small" sx={{ fontSize: '14px' }} />
      </Avatar>
      <Box>
        <Typography level="body-sm" sx={{ fontWeight: 500 }}>
          {t('Profile')}
        </Typography>
      </Box>
    </Box>
  );
};
